import Marquee from "react-fast-marquee";
import { useLanguage } from "@/i18n";

const SLUGS = ["tartufi", "funghi", "ittico", "foie-gras", "carni", "salumi", "formaggi", "fingerfood", "vegetali", "pasta-riso", "condimenti", "puree", "panificati", "gluten-free", "mondo", "no-food"];

export const EditorialMarquee = () => {
    const { t } = useLanguage();
    return (
        <section data-testid="marquee-section" className="border-y border-white/10 bg-[#151921] py-8 md:py-12">
            <Marquee speed={30} gradient={false} pauseOnHover>
                {SLUGS.map((slug) => (
                    <span key={slug} className="mx-6 flex items-center gap-12 md:mx-10">
                        <span className="whitespace-nowrap pb-3 font-display text-3xl font-light italic leading-[1.25] text-[#DBD1BD]/25 transition-colors duration-500 hover:text-[#DBD1BD] md:text-5xl">
                            {t(`catalog.categories.${slug}.name`)}
                        </span>
                        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-midora-red" />
                    </span>
                ))}
            </Marquee>
        </section>
    );
};
